import SignUpWithProductsCardsHomepageFirstFoldComponent from "./sign-up-with-products-cards-homepage-first-fold-component";
import SignUpWithProductsCardsHomepageFirstFoldConfig from "./sign-up-with-products-cards-homepage-first-fold-config";
import SignUpWithProductsCardsHomepageFirstFoldAdvancedConfig from "./sign-up-with-products-cards-homepage-first-fold-advanced-config";

export default {
  SignUpWithProductsCardsHomepageFirstFoldComponent,
  SignUpWithProductsCardsHomepageFirstFoldConfig,
  SignUpWithProductsCardsHomepageFirstFoldAdvancedConfig
};
